import { render, staticRenderFns } from "./AdditionalServicesModal.vue?vue&type=template&id=bedd2314"
import script from "./AdditionalServicesModal.vue?vue&type=script&lang=js"
export * from "./AdditionalServicesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports